import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { coreUserDataSelector } from 'viewModel/selectors/user/coreUserDataSelector';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocaleResourceFile } = LanguageLocaleUtils;

const getText = getLocaleResourceFile(
    'components/Content/PromotionListHandler/PromotionListExclusiveOffersHandler/locales',
    'PromotionListExclusiveOffersHandler'
);

const fields = createSelector(
    coreUserDataSelector,
    createStructuredSelector({
        exclusiveOffers: getTextFromResource(getText, 'exclusiveOffers')
    }),
    (_state, ownProps) => ownProps.title,
    (user, textResources, title) => {
        let customTitle = title;

        if (!user.isAnonymous) {
            customTitle = `${user.firstName ? `${user.firstName}'s` : ''} ${textResources.exclusiveOffers} ❤️`;
        }

        return {
            title: customTitle
        };
    }
);

const withPromotionListExclusiveOffersHandlerProps = wrapHOC(connect(fields));

export {
    fields, withPromotionListExclusiveOffersHandlerProps
};
